/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Svg } from 'app/components';
import { Wrapper, Btn, Text } from './styles';
import { generateUniqueId } from 'utils';

const propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onMax: PropTypes.func,
  idPrefix: PropTypes.string
};

const defaultProps = {
  disabled: false,
  min: 0,
  max: 1000000000,
  onMax: () => { },
  idPrefix: 'input-'
};

const InputNumber = ({ value, min, max, onChange, disabled, onMax, setIsModalOpen, isCombo, idPrefix }) => {
  // const decrease = useCallback(() => {
  //   if (min < value && !disabled) {
  //     onChange(value - 1);
  //   }
  // }, [value, min]);
  const decrease = () => {
    if (min < value && !disabled) {
      onChange(value - 1);
      if (isCombo) {
        setIsModalOpen(false);
      }
    }
  }
  // const increase = useCallback(() => {
  //   if (max > value && !disabled) {
  //     onChange(value + 1);
  //   } else {
  //     onMax();
  //   }
  // }, [value, max]);
  const increase = () => {

    if (max > value && !disabled) {
      onChange(value + 1);
    } else {
      onMax();
    }
  };

  return (
    <Wrapper>
      {isCombo ?
        <>
          <Btn id={`${idPrefix}increase-btn-${generateUniqueId()}`} onClick={increase} aria-label="Increase value">
            <Svg id="plus" />
          </Btn>
        </>
        :
        <>
          <Btn id={`${idPrefix}decrease-btn-${generateUniqueId()}`} onClick={decrease} disabled={min === value} aria-label="Decrease value">
            <Svg id="minus" />
          </Btn>

          <Text>{value}</Text>

          <Btn id={`${idPrefix}increase-btn-${generateUniqueId()}`} onClick={increase} aria-label="Increase value">
            <Svg id="plus" />
          </Btn>
        </>
      }
    </Wrapper >
  );
};

InputNumber.defaultProps = defaultProps;
InputNumber.propTypes = propTypes;
export default React.memo(InputNumber);
